import { ensurePropOf, Slot } from '@farol-ds/react'
import { assignSubComponents } from '@farol-ds/react/utilities/internal'
import classNames from 'classnames'
import { HTMLAttributes } from 'react'

import styles from './list-block.module.scss'
import ListBlockContent from './list-block-content'
import ListBlockItem from './list-block-item'
import ListBlockLeading from './list-block-leading'
import ListBlockText from './list-block-text'
import ListBlockTrailing from './list-block-trailing'

export type ListBlockElement = HTMLUListElement
export type ListBlockProps = HTMLAttributes<ListBlockElement> & {
  kind?: ListBlockKind
  asChild?: boolean
}
export const ListBlockKinds = ['secondary', 'tertiary'] as const
export type ListBlockKind = (typeof ListBlockKinds)[number]

function ListBlockRoot(props: ListBlockProps) {
  const { children, className, kind: kindProp, asChild, ...rest } = props
  const kind = ensurePropOf<ListBlockKind>(ListBlockKinds, kindProp, 'secondary')
  const classes = classNames(
    styles.root,
    {
      [styles[kind]]: !!kind,
    },
    className
  )

  const Component = asChild ? Slot : 'ul'
  return (
    <Component className={classes} {...rest}>
      {children}
    </Component>
  )
}

export const ListBlock = assignSubComponents('ListBlock', ListBlockRoot, {
  Item: ListBlockItem,
  Content: ListBlockContent,
  Text: ListBlockText,
  Leading: ListBlockLeading,
  Trailing: ListBlockTrailing,
})

export * from './list-block-content'
export * from './list-block-item'
export * from './list-block-leading'
export * from './list-block-text'
export * from './list-block-trailing'
